import { Component, OnInit, HostListener } from '@angular/core';
import { Observable } from 'rxjs';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { TCCPConstantValues } from '../../shared/models/tccp-constants';
import { CategoryMapping } from '../../shared/models/category-mapping';
import { ManageCategoryMappingService } from './manage-category-mapping.service';
import { MatDialog } from '@angular/material/dialog';
// import { SELECT_PANEL_INDENT_PADDING_X } from '@angular/material/select'
import { TCCPCommonService } from '../../shared/services/tccp-common.service';
import { ConfirmModalComponent } from '../../shared/components/confirm-modal/confirm-modal.component';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { AdminService } from '../admin.service';
import _ from 'lodash';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-manage-category-mapping',
  templateUrl: './manage-category-mapping.component.html',
  styleUrls: ['./manage-category-mapping.component.scss']
})

export class ManageCategoryMappingComponent implements OnInit {
  public pageTitle = 'View Support Topics Order';
  public alerts: any[] = [];
  public selectedApplication = this.adminService.selectedApplication;
  public audioSupportTopics = [];
  public connectedSupportTopics = [];
  public categoryMapping: CategoryMapping = < CategoryMapping > {};
  public contentTypes = [{ name: 'Internal', value: 'Internal' }, { name: 'External', value: 'External' }];
  public selectedContentType = 'Internal';
  public features = [];
  public pageMode: string = null;
  public categoryMappingList = [];
  public setOpacity = false ;
  public showAdd = false ;

  constructor(
    private fb: FormBuilder, private dialog: MatDialog,
    private categoryMappingService: ManageCategoryMappingService, public commonService: TCCPCommonService,
    private authService: MsalService, private adminService: AdminService) {
  }

  @HostListener('window:beforeunload')
  canDeactivate(): Observable< boolean > | boolean {
    this.alerts = [];
    if ((this.pageMode === 'add' || this.pageMode === 'edit')) {
      const dialogRef = this.dialog.open(ConfirmModalComponent, {
        width: '350px',
        data: TCCPConstantValues.admin.messages.LOST_UNSAVED_MESSAGE,
        position: { top: '100px' },
        id: 'admin-' + this.adminService.selectedApplication
      });
      return dialogRef.afterClosed();
    } else {
      return true;
    }
  }

  ngOnInit() {
    this.setPageMode();
  }

  setPageMode() {
    this.categoryMappingList = [];
    this.audioSupportTopics = [];
    this.connectedSupportTopics = [];
    const selectedApplication = this.selectedApplication.toLowerCase();
    this.categoryMappingService.getCategoryMapping(selectedApplication).subscribe(categoryResponse => {
      if (categoryResponse) {
        if (categoryResponse && categoryResponse.length > 0) {
          this.showAdd = false ;
          this.pageTitle = 'View Support Topics Order';
          this.pageMode = 'view';
          const selectedContentType = this.selectedContentType.toLowerCase();
          const categoryMappingList = categoryResponse.filter(element => {
            return element.category !== undefined && element.category !== '';
          });
          const categoryMappingIdList = categoryResponse.map(element => {
            return element.issueId;
          });
          const categoryListNotInMapping = [];
          this.adminService.getFlow(selectedContentType, selectedApplication).subscribe(response => {
            if (response && response.length > 0) {
              response.forEach(a => {
                categoryMappingList.forEach(b => {
                  if ((a.status === 'draft' && (a.publishedDate && a.publishedDate !== '')) || (a.status === 'published')) {
                    if (a.featureType === selectedContentType) {
                      if (categoryMappingIdList.indexOf(a.issueId) > -1) {
                        if (a.issueId === b.issueId) {
                          this.categoryMappingList.push(b);
                        }
                      } else {
                        if (a.category && a.category !== '') {
                          categoryListNotInMapping.push(a);
                        }
                      }
                    }
                  }
                });
              });
            }
            if (this.categoryMappingList && this.categoryMappingList.length > 0) {
              let categoryListNotInMapping1 = [];
              const requestArr = [];
              if (categoryListNotInMapping && categoryListNotInMapping.length > 0) {
                categoryListNotInMapping1 = _.uniqBy(categoryListNotInMapping, 'issueId');
                const categoryListNotInMapping2 = _.orderBy(categoryListNotInMapping1, ['lastModifiedDate'], ['asc']);
                const order = Math.max.apply(Math, categoryResponse.map(o => o.order));

                categoryListNotInMapping2.forEach((y, index) => {
                  const obj = {
                    category: y.category,
                    order: order + index,
                    supportTopicName: y.controls[0]['featureName'],
                    issueId: y.issueId
                  };
                  requestArr.push(obj);
                });
              }
              this.categoryMappingList = this.categoryMappingList.concat(requestArr);
              this.setMappingList(true);
            } else {
              this.setMappingListForAdd();
            }
          });
        } else {
          this.setMappingListForAdd();
        }
      }
    });
  }

  setMappingListForAdd() {
    this.categoryMappingList = [];
    if (this.categoryMappingList && this.categoryMappingList.length === 0) {
      this.showAdd = true;
    }
    this.pageTitle = 'View Support Topics Order';
    this.pageMode = 'view';
    this.adminService.getFlow(this.selectedContentType.toLowerCase()).subscribe(data => {
      if (data && data.length > 0) {
        this.categoryMappingList = data.filter(element => {
          return element.category !== undefined &&
            element.category !== '';
        });
        if (this.categoryMappingList && this.categoryMappingList.length > 0) {
          this.setMappingList(false );
        }
      }
    });
  }

  setMappingList(fromCategory) {
    this.audioSupportTopics = [];
    this.connectedSupportTopics = [];
    const order = Math.max.apply(Math, this.categoryMappingList.map(o => o.order));

    this.categoryMappingList.forEach((y, index) => {

      const obj = {
        category: y.category,
        order: y.order, featureName: fromCategory ? y.supportTopicName : y.controls[0]['featureName'],
        issueId: y.issueId
      };
      if (this.selectedApplication === 'toyota') {
        if (obj && obj.category === 'Audio Multimedia') {
          this.audioSupportTopics.push(obj);
          this.audioSupportTopics = _.orderBy(this.audioSupportTopics, ['order'], ['asc']);
        } else {
          this.connectedSupportTopics.push(obj);
          this.connectedSupportTopics = _.orderBy(this.connectedSupportTopics, ['order'], ['asc']);
        }
      } else {
        if (obj && obj.category === 'Lexus Multimedia') {
          this.audioSupportTopics.push(obj);
          this.audioSupportTopics = _.orderBy(this.audioSupportTopics, ['order'], ['asc']);
        } else {
          this.connectedSupportTopics.push(obj);
          this.connectedSupportTopics = _.orderBy(this.connectedSupportTopics, ['order'], ['asc']);
        }
      }
    });
  }

  setSupportTopicOrder(requestArray, previousIndex, currentIndex) {
    const temp = Object.assign({}, requestArray[currentIndex]);
    if (previousIndex > currentIndex) {
      requestArray.forEach((x, index) => {
        if (index === currentIndex) {
          x.order = requestArray[currentIndex + 1].order;
          return;
        }
      });
      requestArray.forEach((x, index) => {
        if (index > currentIndex && index < previousIndex) {
          x.order = requestArray[index + 1].order;
        }
      });
      requestArray.forEach((x, index) => {
        if (index === previousIndex) {
          x.order = temp.order;
          return;
        }
      });
    } else {
      requestArray.forEach((x, index) => {
        if (index === currentIndex) {
          x.order = requestArray[currentIndex - 1].order;
          return;
        }
      });
      for (let index = currentIndex; index > previousIndex; index--) {
        if (index > previousIndex && index < currentIndex) {
          requestArray[index].order = requestArray[index - 1].order;
        }
      }
      requestArray.forEach((x, index) => {
        if (index === previousIndex) {
          x.order = temp.order;
          return;
        }
      });
    }
    return requestArray;
  }

  dropConnectedSupportTopics(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.connectedSupportTopics, event.previousIndex, event.currentIndex);
    //  this.connectedSupportTopics = this.setSupportTopicOrder(this.connectedSupportTopics, event.previousIndex, event.currentIndex);
  }

  dropAudioSupportTopics(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.audioSupportTopics, event.previousIndex, event.currentIndex);
    //  this.audioSupportTopics = this.setSupportTopicOrder(this.audioSupportTopics, event.previousIndex, event.currentIndex);
  }

  setRequestParameter(requestArray) {
    const requestParameter = [];
    requestArray.forEach((x, index) => {
      const obj: CategoryMapping = < CategoryMapping > {};
      obj.category = x.category;
      obj.createdBy = this.authService.instance.getActiveAccount().username;
      obj.division = this.adminService.selectedApplication;
      obj.issueId = x.issueId;
      obj.order = index;
      obj.supportTopicName = x.featureName;
      obj.featureType = x.featureType;
      requestParameter.push(obj);
    });
    return requestParameter;
  }


  onSave() {
    const connectedArray = this.setRequestParameter(this.connectedSupportTopics);
    const audioArray = this.setRequestParameter(this.audioSupportTopics);
    const requestParameter = audioArray.concat(connectedArray);
    this.adminService.updateCategoryMappingOrder(requestParameter).subscribe(orderResponse => {
      this.pageMode = 'view';
      this.pageTitle = 'View Support Topics Order';
      this.setOpacity = true;
      this.showAdd = false ;
      this.showAlertMessages('success', TCCPConstantValues.admin.messages.SUPPORT_TOPIC_ORDER_SUCCESS_MESSAGE);
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    });
  }

  onCancel() {
    this.alerts = [];
    this.openCancelDialog();
  }

  openCancelDialog(): void {
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      width: '350px',
      data: TCCPConstantValues.admin.messages.LOST_UNSAVED_MESSAGE,
      id: 'admin-' + this.adminService.selectedApplication
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (this.pageMode === 'add') {
          this.audioSupportTopics = [];
          this.connectedSupportTopics = [];
        } else if (this.pageMode === 'edit') {
          this.contentTypeChange();
          this.pageMode = 'view';
          this.setOpacity = true;
        }
      }
    });
  }

  goToEditMapping() {
    this.alerts = [];
    this.pageMode = 'edit';
    this.pageTitle = 'Edit Support Topics Order';
    this.setOpacity = false ;
  }

  goToAddMapping() {
    this.alerts = [];
    this.pageMode = 'add';
    this.pageTitle = 'Add Support Topics Order';
    this.setOpacity = false ;
  }

  goToViewMapping() {
    this.alerts = [];
    this.pageTitle = 'View Support Topics Order';
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      width: '350px',
      data: TCCPConstantValues.admin.messages.LOST_UNSAVED_MESSAGE,
      id: 'admin-' + this.adminService.selectedApplication,
      position: { top: '100px' }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.pageMode = 'view';
    });
  }

  contentTypeChange() {
    this.alerts = [];
    this.setPageMode();
  }

  onEdit() {
    this.alerts = [];
    this.pageMode = 'edit';
  }

  public showAlertMessages(messageType, message) {
    this.alerts = [];
    if (this.alerts.length === 0) {
      this.alerts.push({
        type: messageType,
        msg: message
      });
    }
  }

  closeAlerts() {
    this.alerts = [];
  }

}
